import gql from 'graphql-tag';

export const EditorBreadcrumbsQuery =
	// eslint-disable-next-line graphql-relay-compat/no-experimental-directives -- Read http://go/cfe-no-experimental-directives
	gql`
		query EditorBreadcrumbsQuery($contentId: ID!) @experimental {
			experimentalEditorBreadcrumbs(contentId: $contentId) {
				breadcrumbs {
					title
					url
				}
			}
		}
	`;
